/**
 * Operator utility functions and mappings for PAL configuration
 */

// Operator mapping from UI display to JSON format
export const OPERATOR_MAP: Record<string, string> = {
  "=": "EQUALS",
  "==": "EQUALS",
  "!=": "NOT_EQUALS",
  "<>": "NOT_EQUALS",
  ">": "GREATER_THAN",
  ">=": "GREATER_THAN_OR_EQUALS",
  "<": "LESS_THAN",
  "<=": "LESS_THAN_OR_EQUALS",
  IN: "IN",
  in: "IN",
  In: "IN",
  "NOT IN": "NOT_IN",
  "not in": "NOT_IN",
  BETWEEN: "BETWEEN",
  between: "BETWEEN",
  Between: "BETWEEN",
  LIKE: "LIKE",
  like: "LIKE",
  "NOT LIKE": "NOT_LIKE",
  "not like": "NOT_LIKE",
  "IS NULL": "IS_NULL",
  "is null": "IS_NULL",
  "IS NOT NULL": "IS_NOT_NULL",
  "is not null": "IS_NOT_NULL",
};

// Reverse operator mapping from JSON format to UI display
export const REVERSE_OPERATOR_MAP: Record<string, string> = {
  EQUALS: "=",
  Equals: "=",
  equals: "=",
  NOT_EQUALS: "!=",
  GREATER_THAN: ">",
  GREATER_THAN_OR_EQUALS: ">=",
  LESS_THAN: "<",
  LESS_THAN_OR_EQUALS: "<=",
  IN: "IN",
  In: "IN",
  in: "IN",
  NOT_IN: "NOT IN",
  BETWEEN: "BETWEEN",
  Between: "BETWEEN",
  between: "BETWEEN",
  LIKE: "LIKE",
  NOT_LIKE: "NOT LIKE",
  IS_NULL: "IS NULL",
  IS_NOT_NULL: "IS NOT NULL",
};

/**
 * Map operator from UI display format to JSON format
 */
export const mapOperatorToJSON = (
  operator: string | null | undefined,
): string => {
  if (operator == null || typeof operator !== "string") {
    return "";
  }
  return OPERATOR_MAP[operator] ?? operator.toUpperCase().replace(/\s+/g, "_");
};

/**
 * Map operator from JSON format to UI display format
 */
export const mapOperatorToUI = (
  jsonOperator: string | null | undefined,
): string => {
  if (jsonOperator == null || typeof jsonOperator !== "string") {
    return "";
  }
  return (
    REVERSE_OPERATOR_MAP[jsonOperator] ??
    REVERSE_OPERATOR_MAP[jsonOperator.toUpperCase()] ??
    jsonOperator
  );
};
